<template>
  <!-- Main -->
  <div id="main" v-if="initialized">
    <!-- 商店 -->
    <div id="mainStore">
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item">
              <EditBoxBoolean
                :code="'is_enabled'"
                :name="$t('AccountSettingStore.Enable_Ordering')"
                :value="data.is_enabled"
                :dbTable="'accounts'"
                :key="'is_enabled'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
          </div>
          <div class="box" v-show="userType === 'gaa' || userType === 'si'">
            <div class="item">
              <EditBoxBoolean
                :code="'is_mobile_payment'"
                :name="$t('AccountSettingStore.Online_Payment')"
                :value="data.is_mobile_payment"
                :dbTable="'business'"
                :key="'is_mobile_payment'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
          </div>
        </div>
        <div class="areaV">
          <div class="box">
            <span class="title">{{ $t('AccountSettingStore.System_Status') }}</span>
            <div class="item">
              <EditBoxBoolean
                :code="'is_eat_in'"
                :name="$t('AccountSettingStore.Dine_In')"
                :value="data.is_eat_in"
                :dbTable="'business'"
                :key="'is_eat_in'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_to_go'"
                :name="$t('AccountSettingStore.Self_Pickup')"
                :value="data.is_to_go"
                :dbTable="'business'"
                :key="'is_to_go'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_delivery'"
                :name="$t('AccountSettingStore.Delivery')"
                :value="data.is_delivery"
                :dbTable="'business'"
                :key="'is_delivery'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
          </div>
        </div>
        <div v-show="userType === 'gaa' || userType === 'si'" class="areaV">
          <div class="box">
            <span class="title">{{ $t('AccountSettingStore.Payment_Method') }}</span>
            <div style="display: flex; justify-content: space-between;">
              <div
                style="display: flex; flex-direction: column; align-items: center;"
              >
                <span class="content">{{ $t('AccountSettingStore.Dine_In') }}</span>
                <div class="item">
                  <EditBoxBoolean
                    :code="'is_eat_in_cash'"
                    :name="$t('AccountSettingStore.Cash')"
                    :value="data.is_eat_in_cash"
                    :dbTable="'business'"
                    :key="'is_eat_in_cash'"
                    @toggle-switch="toggleSwitch($event)"
                  />
                </div>
                <div class="item">
                  <EditBoxBoolean
                    :code="'is_eat_in_pay'"
                    :name="$t('AccountSettingStore.Online')"
                    :value="data.is_eat_in_pay"
                    :dbTable="'business'"
                    :key="'is_eat_in_pay'"
                    @toggle-switch="toggleSwitch($event)"
                  />
                </div>
              </div>
              <div
                style="display: flex; flex-direction: column; align-items: center;"
              >
                <span class="content">{{ $t('AccountSettingStore.Self_Pickup') }}</span>
                <div class="item">
                  <EditBoxBoolean
                    :code="'is_to_go_cash'"
                    :name="$t('AccountSettingStore.Cash')"
                    :value="data.is_to_go_cash"
                    :dbTable="'business'"
                    :key="'is_to_go_cash'"
                    @toggle-switch="toggleSwitch($event)"
                  />
                </div>
                <div class="item">
                  <EditBoxBoolean
                    :code="'is_to_go_pay'"
                    :name="$t('AccountSettingStore.Online')"
                    :value="data.is_to_go_pay"
                    :dbTable="'business'"
                    :key="'is_to_go_pay'"
                    @toggle-switch="toggleSwitch($event)"
                  />
                </div>
              </div>
              <div
                style="display: flex; flex-direction: column; align-items: center;"
              >
                <span class="content">{{ $t('AccountSettingStore.Delivery') }}</span>
                <div class="item">
                  <EditBoxBoolean
                    :code="'is_delivery_cash'"
                    :name="$t('AccountSettingStore.Cash')"
                    :value="data.is_delivery_cash"
                    :dbTable="'business'"
                    :key="'is_delivery_cash'"
                    @toggle-switch="toggleSwitch($event)"
                  />
                </div>
                <div class="item">
                  <EditBoxBoolean
                    :code="'is_delivery_pay'"
                    :name="$t('AccountSettingStore.Online')"
                    :value="data.is_delivery_pay"
                    :dbTable="'business'"
                    :key="'is_delivery_pay'"
                    @toggle-switch="toggleSwitch($event)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <span class="title">{{ $t('AccountSettingStore.Announcement') }}</span>
            <EditBoxRichEditor
              :code="'content'"
              :name="$t('AccountSettingStore.Announcement')"
              :dbTable="'business_info'"
              :key="'content'"
              v-model="data.content"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}${$t('AccountSettingStore.Announcement')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
          </div>
          <div class="box inputL">
            <span class="title">{{ $t('AccountSettingStore.Store_Information') }}</span>
            <EditBoxInput
              :code="'business_name'"
              :name="$t('AccountSettingStore.Owner_Name')"
              :dbTable="'business'"
              :key="'business_name'"
              :isDisabled="userType === 'eaa' || userType === 'si'"
              v-model="data.business_name"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}${$t('AccountSettingStore.Owner_Name')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'tax_id_number'"
              :name="$t('AccountSettingStore.Tax_ID')"
              :dbTable="'business'"
              :key="'tax_id_number'"
              :isDisabled="userType === 'eaa' || userType === 'si'"
              v-model="data.tax_id_number"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}${$t('AccountSettingStore.Tax_ID')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'name'"
              :name="$t('AccountSettingStore.Store_Name')"
              :dbTable="'business'"
              :key="'name'"
              v-model="data.name"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}${$t('AccountSettingStore.Store_Name')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'email'"
              :name="$t('AccountSettingStore.Email')"
              :dbTable="'business'"
              :key="'email'"
              v-model="data.email"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}${$t('AccountSettingStore.Email')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'phone'"
              :name="$t('AccountSettingStore.Phone')"
              :dbTable="'business'"
              :key="'phone'"
              v-model="data.phone"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}${$t('AccountSettingStore.Phone')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'code'"
              :name="$t('AccountSettingStore.Store_Code')"
              :dbTable="'business'"
              :key="'code'"
              :isDisabled="userType === 'eaa' || userType === 'si'"
              v-model="data.code"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}${$t('AccountSettingStore.Store_Code')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'address'"
              :name="$t('AccountSettingStore.Address')"
              :dbTable="'business'"
              :key="'address'"
              v-model="data.address"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}${$t('AccountSettingStore.Address')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
          </div>
        </div>
        <div class="areaV">
          <div class="box">
            <span class="title">{{ $t('AccountSettingStore.Operating_Information') }}</span>
            <EditBoxTextarea
              :code="'info'"
              :name="$t('AccountSettingStore.Operating_Information')"
              :dbTable="'business'"
              :key="'info'"
              v-model="data.info"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}${$t('AccountSettingStore.Operating_Information')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
          </div>
          <div class="box inputL" v-show="userType === 'gaa' || userType === 'si'">
            <span class="title">{{ $t('AccountSettingStore.Applicant_Information') }}</span>
            <EditBoxInput
              :code="'boss_email'"
              :name="$t('AccountSettingStore.Email')"
              :dbTable="'business'"
              :key="'boss_email'"
              v-model="data.boss_email"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}${$t('AccountSettingStore.Email')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'boss_phone'"
              :name="$t('AccountSettingStore.Phone')"
              :dbTable="'business'"
              :key="'boss_phone'"
              v-model="data.boss_phone"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}${$t('AccountSettingStore.Phone')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
          </div>
          <div class="box inputS" v-show="userType === 'gaa' || userType === 'si'">
            <span class="title">{{ $t('AccountSettingStore.System_Data') }}</span>
            <EditBoxInput
              :code="'shop_id'"
              :name="`Wifiotg${$t('AccountSettingStore.Store')}${$t('AccountSettingStore.ID')}`"
              :dbTable="'accounts'"
              :key="'shop_id'"
              v-model="data.shop_id"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}Wifiotg${$t('AccountSettingStore.Store')}${$t('AccountSettingStore.ID')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'app_id'"
              :name="'WEB SSO ID'"
              :dbTable="'account_sso'"
              :key="'app_id'"
              v-model="data.app_id"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}WEB SSO ID`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'line_add_friend_url'"
              :name="`LINE${$t('AccountSettingStore.Add')}${$t('AccountSettingStore.Friend')}${$t('AccountSettingStore.Link')}`"
              :dbTable="'accounts'"
              :key="'line_add_friend_url'"
              v-model="data.line_add_friend_url"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}LINE${$t('AccountSettingStore.Add')}${$t('AccountSettingStore.Friend')}${$t('AccountSettingStore.Link')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'line_basic_id'"
              :name="`LINE${$t('AccountSettingStore.Add')}${$t('AccountSettingStore.Friend')}${$t('AccountSettingStore.ID')}`"
              :dbTable="'accounts'"
              :key="'line_basic_id'"
              v-model="data.line_basic_id"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}LINE${$t('AccountSettingStore.Add')}${$t('AccountSettingStore.Friend')}${$t('AccountSettingStore.ID')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'line_channel_image_url'"
              :name="`LINE${$t('AccountSettingStore.Add')}${$t('AccountSettingStore.QRCode')}${$t('AccountSettingStore.Link')}`"
              :dbTable="'accounts'"
              :key="'line_channel_image_url'"
              v-model="data.line_channel_image_url"
              :placeholder="`${$t('AccountSettingStore.Please_Enter')}LINE${$t('AccountSettingStore.Add')}${$t('AccountSettingStore.QRCode')}${$t('AccountSettingStore.Link')}`"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />

            <div class="item">
              <div style="display: flex; flex-direction: column;">
                <span class="content">QC1.0 Menu URL</span>
                <!-- <span class="remark" style="margin-top: -5px;"> {{ $t('AccountSettingStore.View_Only') }} </span> -->
              </div>
              <div class="number" style="margin-left: 10px;">
                <input
                  class="input"
                  type="text"
                  :disabled="true"
                  v-model="managerInfo['menuUrl']"
                />
              </div>
            </div>
            <div class="item">
              <div style="display: flex; flex-direction: column;">
                <span class="content">QC1.0 Order URL</span>
                <!-- <span class="remark" style="margin-top: -5px;"> {{ $t('AccountSettingStore.View_Only') }} </span> -->
              </div>
              <div class="number" style="margin-left: 10px;">
                <input
                  class="input"
                  type="text"
                  :disabled="true"
                  v-model="managerInfo['orderUrl']"
                />
              </div>
            </div>
            <div class="item">
              <div style="display: flex; flex-direction: column;">
                <span class="content">QC1.0 Info URL</span>
                <!-- <span class="remark" style="margin-top: -5px;"> {{ $t('AccountSettingStore.View_Only') }} </span> -->
              </div>
              <div class="number" style="margin-left: 10px;">
                <input
                  class="input"
                  type="text"
                  :disabled="true"
                  v-model="managerInfo['infoUrl']"
                />
              </div>
            </div>
            <div class="item">
              <div style="display: flex; flex-direction: column;">
                <span class="content">QC2.0 Menu URL</span>
                <!-- <span class="remark" style="margin-top: -5px;"> {{ $t('AccountSettingStore.View_Only') }} </span> -->
              </div>
              <div class="number" style="margin-left: 10px;">
                <input
                  class="input"
                  type="text"
                  :disabled="true"
                  :value="`${data.end_point}/tw/food/${data.shop_id}/`"
                />
              </div>
            </div>

            <!-- <EditBoxInput
              :code="'menuUrl2'"
              :name="'QC2.0 Menu URL'"
              :dbTable="'accounts'"
              :key="'menuUrl2'"
              v-model="managerInfo.menuUrl2"
              :placeholder="'QC2.0 Menu URL'"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            /> -->
            <!-- <EditBoxInput
              :code="'app_key'"
              :name="'System Client ID'"
              :dbTable="'app_keys'"
              :key="'app_key'"
              :disabled="true"
              v-model="data.app_key"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            /> -->
            <!-- <EditBoxInput
              :code="'app_secret'"
              :name="'System Client Secret'"
              :dbTable="'app_keys'"
              :key="'app_secret'"
              :disabled="true"
              v-model="data.app_secret"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            /> -->
            <!-- 先用EditBoxInput變形，新增時EditBoxInput無法顯示新的值-->
            <div class="item">
              <div style="display: flex; flex-direction: column;">
                <span class="content">Client Id</span>
                <span class="remark" style="margin-top: -5px;"> {{ $t('AccountSettingStore.View_Only') }} </span>
              </div>
              <div class="number" style="margin-left: 10px;">
                <input
                  class="input"
                  type="text"
                  :disabled="true"
                  v-model="data.app_key"
                />
                
              </div>
            </div>
            <div class="item">
              <div style="display: flex; flex-direction: column;">
                <span class="content">Client Secret</span>
                <span class="remark" style="margin-top: -5px;"> {{ $t('AccountSettingStore.View_Only') }} </span>
              </div>
              <div class="number" style="margin-left: 10px;">
                <input
                  class="input"
                  type="text"
                  :disabled="true"
                  v-model="data.app_secret"
                />
              </div>
            </div>
            <template v-if="!data.app_key && !data.app_secret">
              <el-button type="primary" class="btn-add-ps" @click="addAppKeys">
                <i class="el-icon-plus"></i>
                {{ $t('AccountSettingStore.Create') }} Client ID/Secret
              </el-button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditBoxBoolean from "src/components/GaaConsole/EditBoxBoolean.vue";
import EditBoxInput from "src/components/GaaConsole/EditBoxInput.vue";
import EditBoxTextarea from "src/components/GaaConsole/EditBoxTextarea.vue";
import EditBoxRichEditor from "src/components/GaaConsole/EditBoxRichEditor.vue";
import {
  updateAccounts,
  updateBusiness,
  updateBusinessInfo,
  updateAccountSSo
} from "src/javascripts/generalPages/updateForConsoleLog";
import { fetchSettings } from "src/javascripts/generalPages/fetchForConsoleLog";
import { createAppKeys } from "src/javascripts/generalPages/postForConsoleLog";
import { fetchManagerInfo } from "src/pages/Stores/Retail/common/fetchData";

export default {
  components: {
    EditBoxBoolean,
    EditBoxInput,
    EditBoxTextarea,
    EditBoxRichEditor
  },
  data() {
    return {
      managerInfo: {
        menuUrl: "",
        orderUrl:"",
        infoUrl: "",
        end_point:""
      },
      data: {
        is_enabled: false,
        is_mobile_payment: false,
        is_eat_in: false,
        is_to_go: false,
        is_delivery: false,
        is_eat_in_cash: false,
        is_eat_in_pay: false,
        is_to_go_cash: false,
        is_to_go_pay: false,
        is_delivery_cash: false,
        is_delivery_pay: false,
        tax_id_number: "",
        name: "",
        boss_email: "",
        boss_phone: "",
        email: "",
        phone: "",
        code: "",
        address: "",
        shop_id: "",
        line_add_friend_url: "",
        line_basic_id: "",
        line_channel_image_url: "",
        info: "",
        content: "",
        app_id: "",
        app_key: "",
        app_secret: "",
        business_name: "",
      },
      initialized: false,
      editList: []
    };
  },
  props: {
    accountId: {
      type: Number,
      default: 1
    },
    value: {
      type: String,
      default: ""
    }
  },
  computed: {
    type() {
      return this.$route.params.type || 'gaa';
    },
    userType() {
      return this.$store.getters.userType;
    }
  }, 
  created: function() {
    // fetch value
    this.getShopSettings();
  },
  methods: {
    getShopSettings() {
      fetchSettings(this.accountId, this.$route.params.type)
      .then(fetchSettingsRes => {
        if (fetchSettingsRes.data.length > 0) {
          const fetchSettingsResData = fetchSettingsRes.data[0]
          this.setData(fetchSettingsResData);
          // fetchSettingsResData.si_accounts_id
          fetchManagerInfo(fetchSettingsResData.si_accounts_id, 'gaa', undefined, fetchSettingsResData.business_id)
          .then(res => {
            if(res.data.length > 0) {
              this.managerInfo = res.data[0];
            };
          })
          .catch(err => {
            console.log("fetchManagerInfo err: ", err.stack)
          })
        } else {
          throw new Error("FetchData error!");
        }
      })
      .catch(err => {
        console.log("err: ", err);
        this.$message({
          type: "error",
          message: `商店：${this.accountId} ，無法取得資料！`
        });
      });
    },
    setData(fetchData) {
      for (var prop in fetchData) {
        if (fetchData[prop] === 1) fetchData[prop] = true;
        if (fetchData[prop] === 0) fetchData[prop] = false;
      }
      this.data = Object.assign(this.data, fetchData);
      this.initialized = true;
    },
    toggleSwitch(event) {
      this.data[event.code] = event.mutation;
      this.data = Object.assign(this.data);

      let updateBooleanData = {
        key: event.code,
        value: event.mutation,
        dbTable: event.dbTable,
        label: event.name,
        type: event.type
      };
      this.edit(updateBooleanData);
    },
    updateInput(event) {
      let updateInputData = {
        key: event.code,
        value: event.mutation,
        dbTable: event.dbTable,
        origin: event.origin,
        label: event.name,
        type: event.type
      };
      this.edit(updateInputData);
    },
    edit(data) {
      let label = data.label;
      if (data.key === "name") data.dbTable = "accounts&business";
      switch (data.dbTable) {
        case "accounts":
          updateAccounts(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "business":
          updateBusiness(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "business_info":
          updateBusinessInfo(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "accounts&business":
          updateAccounts(data, this.accountId, this.type)
            .then(res => updateBusiness(data, this.accountId, this.type))
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "account_sso":
          let fields = Object.assign(
            {},
            {
              name: this.data.name,
              accountId: this.accountId,
              appId: data.value
            }
          );
          Object.assign(data, {
            fields: fields
          });
          updateAccountSSo(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "app_keys": 
            break;
        default:
          console.log("undefined db table: " + data.dbTable);
          break;
      }
    },
    editSuccess(res, label) {
      console.log(res);
      this.$message({
        type: "success",
        message: `${label} 修改成功！`
      });
      this.$emit("saved", true);
    },
    editError(err) {
      console.log(err);
      this.$message({
        type: "error",
        message: "修改失敗"
      });
    },
    changeEditStatus(event) {
      let editDataIndex = this.editList.findIndex(d => d.code == event.code);
      if (event.warning) {
        if (editDataIndex == -1) {
          this.editList.push(event);
        } else {
          let editData = this.editList.find(d => d.code == event.code);
          Object.assign(editData, event);
        }
      } else {
        if (editDataIndex != -1) {
          this.editList.splice(editDataIndex, 1);
        }
      }
    },
    addAppKeys () {
      createAppKeys(this.accountId, this.type)
      .then(res => {
        this.$message({
          type: "success",
          message: `Client ID/Secret 新增成功！`
        });
        
        // this.$emit("saved", true);
        this.$nextTick(function() {
          this.data.app_key = res.data.clientId;
          this.data.app_secret = res.data.clientSecret;
        });
        
        
      })
      .catch(() => {
        this.$message({
          type: "error",
          message: `新增失敗！`
        })
      });
    }
  },
  watch: {
    editList: function(newVal, oldVal) {
      if (newVal.length > 0) {
        let editStatusData = {
          value: this.value
        };
        this.$emit("edit-status", editStatusData);
      } else {
        let savedStatusData = {
          value: this.value
        };
        this.$emit("saved-status", savedStatusData);
      }
    }
  }
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css"></style>
<style scoped>
.btn-add-ps {
  background-color: #F96332;
  border-color: white;
  margin-top: 5px
}
.btn-add-ps:hover {
  background-color: #ff8d67;
  border-color: white;
  margin-top: 5px
}
</style>